import React from 'react'
import Chart from "react-apexcharts";

const ClosedTestBarChart = ({
    categories = [],
    series = [],
}) => {
    const options = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "30%",
                endingShape: "rounded",
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 1,
            colors: ["transparent"],
        },
        colors: ["#00B050", "#A9A9A9"],
        xaxis: {
            categories: categories,
            labels: {
                style: {
                    colors: "#8e8e8e",
                    fontSize: "12px",
                },
            },
        },
        yaxis: {
            min: 0,
            max: 2.5,
            tickAmount: 5,
            labels: {
                style: {
                    colors: "#8e8e8e",
                    fontSize: "12px",
                },
            },
        },
        grid: {
            borderColor: "#e7e7e7",
            strokeDashArray: 3,
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
            markers: {
                radius: 12,
            },
            labels: {
                colors: "#000",
            },
        },
        tooltip: {
            y: {
                formatter: (val) => val,
            },
        },
        title: {
            text: "Results from closed test runs",
            align: "left",
            style: {
                fontSize: "14px",
                fontWeight: "bold",
            },
        },
    };

    return (
        <div style={{ padding: '10px', border: '2px solid #e5e7eb', borderRadius: '8px' }}>
            <Chart options={options} series={series} type="bar" height={350} />
        </div>
    )
}

export default ClosedTestBarChart
